<template>
<div>
  <section class="content">
    <div class="box info-box">
      <div class="box-header with-border">
        Filter By
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-md-3" v-if="this.$store.state.user.type == 'admin'">
            <div class="form-group">
              <label for="Session">Session</label>
              <v-select v-model="filterSession" name="financial_year_id" label="name" :options="sessions" placeholder="Select Session" v-on:input="getSessionWiseRecord"></v-select>
              
              <has-error
                :form="form"
                field="financial_year_id"
              ></has-error>
            </div>
          </div>
          <div class="col-md-3" v-if="this.$store.state.user.type == 'admin'">
            <label for="Branch">Branch</label>
            <v-select v-model="branchDetails" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getBranchWiseRecord"></v-select>
            
            <has-error
              :form="form"
              field="branch_id"
            ></has-error>
          </div>
        </div>
      </div>
      <!-- /.box-body -->
    </div>
     <!-- Default box -->
      <div class="info-box"  v-if="canAccess('bank-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">FY Opening Balance</h3>
          
          <div class="box-tools">
            <button type="button" class="btn btn-success btn-sm" @click="newModal" v-if="canAccess('bank-create')">
              <i class="fa fa-plus"></i> Add New
            </button>
          </div>

        </div>
        <div class="box-body">
          <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
                <select v-model="per_page" name="per_page" @change="changeFilter()" aria-controls="example1" class="form-control input-sm">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
            <div class="col-sm-6 col-xs-6">
              <div class="input-group pull-right input-group-sm" style="width: 150px;">
                <input type="text" v-model="table_search" @keyup.enter="changeFilter()" name="table_search" class="form-control pull-right" placeholder="Search">

                <div class="input-group-btn">
                  <button type="button" @click="changeFilter()" class="btn btn-default"><i class="fa fa-search"></i></button>
                </div>
              </div>
            </div>
          </div>
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr. No.</th>
                <th>Financial Year</th>
                <th class="hidden-xs">Branch</th>
                <th class="hidden-xs">Ledger</th>
                <th class="hidden-xs">Group</th>
                <th class="hidden-xs">Opening Balance</th>
                <!-- <th class="hidden-xs">Remark</th> -->
                <!-- <th class="hidden-xs">Status</th> -->
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rows" :key="index">
                <td class="hidden-xs">{{ (index + pagination.from) }}</td>
                <td><span v-if="row.session">{{ row.session.session }}</span></td>
                <td><span v-if="row.branch">{{ row.branch.name }}</span></td>
                <td class="hidden-xs"><span v-if="row.ledger">{{ row.ledger.name }}</span></td>
                <td class="hidden-xs"><span v-if="row.group">{{ row.group.group }}</span></td>
                <td class="hidden-xs">{{ row.openingBalance }}</td>
                <!-- <td class="hidden-xs">{{ row.remark }}</td> -->
                <!-- <td class="hidden-xs">
                  <div v-if="row.status == 'active'">
                    <span class="label label-success">Active</span>
                  </div>
                  <div v-else>
                    <span class="label label-danger">InActive</span>
                  </div>
                </td> -->
                <td>
                  <div class="btn-group">
                    <button
                      v-if="canAccess('bank-update')"
                      @click="editModal(row)"
                      class="btn btn-success btn-xs"
                    >
                      <i class="fa fa-pencil"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer clearfix" v-if="pagination.current_page > 0">
          <div class="row">
            <div class="col-sm-4">
              Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries
            </div>
            <div class="col-sm-8">
              <ul class="pagination pagination-sm no-margin pull-right">
                <li @click="changeFilter(null, 'first')"><a href="#">&laquo;</a></li>
                <li @click="changeFilter(null, 'prev')"><a href="#">Prev</a></li>

                <!-- <li v-if="pagination.current_page > 4" @click="changeFilter( pagination.current_page - 4 )"><a href="#">{{pagination.current_page - 4}}</a></li> -->
                <li v-if="pagination.current_page > 3" @click="changeFilter( pagination.current_page - 3 )"><a href="#">{{pagination.current_page - 3}}</a></li>
                <li v-if="pagination.current_page > 2" @click="changeFilter( pagination.current_page - 2 )"><a href="#">{{pagination.current_page - 2}}</a></li>
                <li v-if="pagination.current_page > 1" @click="changeFilter( pagination.current_page - 1 )"><a href="#">{{pagination.current_page - 1}}</a></li>
                <li class="active" @click="changeFilter( pagination.current_page )"><a href="#">{{ pagination.current_page }}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 1 )"><a href="#">{{pagination.current_page + 1}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 5)" @click="changeFilter( pagination.current_page + 2 )"><a href="#">{{pagination.current_page + 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 6)" @click="changeFilter( pagination.current_page + 3 )"><a href="#">{{pagination.current_page + 3}}</a></li>
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.current_page + 4 )"><a href="#">{{pagination.current_page + 4}}</a></li> -->
                <li><a href="#">...</a></li>
                
                <!-- <li v-if="pagination.current_page < (pagination.last_page - 4)" @click="changeFilter( pagination.last_page - 4 )"><a href="#">{{pagination.last_page - 4}}</a></li> -->
                <li v-if="pagination.current_page < (pagination.last_page - 3)" @click="changeFilter( pagination.last_page - 3 )"><a href="#">{{pagination.last_page - 3}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 2)" @click="changeFilter( pagination.last_page - 2 )"><a href="#">{{pagination.last_page - 2}}</a></li>
                <li v-if="pagination.current_page < (pagination.last_page - 1)" @click="changeFilter( pagination.last_page - 1 )"><a href="#">{{pagination.last_page - 1}}</a></li>
                <li @click="changeFilter( pagination.last_page )"><a href="#">{{pagination.last_page}}</a></li>

                <li @click="changeFilter(null, 'next')"><a href="#">Next</a></li>
                <li @click="changeFilter(null, 'last')"><a href="#">&raquo;</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- /.box -->
  </section>    
  <div class="modal fade" id="newModal">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header bg-aqua">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 v-show="!editMode" class="modal-title">Add New</h4>
          <h4 v-show="editMode" class="modal-title">Update</h4>
          
        </div>
        <form @submit.prevent.once="editMode ? updateRecord() : createFYOpeningBalance()">
          <div class="modal-body">
            <!-- general form elements disabled -->
            <div class="card card-warning">
              <!-- /.card-header -->
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-6">
                    <!-- text input -->
                    <div class="form-group">
                      <label for="Session">Session</label>
                      <v-select v-model="session" name="financial_year_id" label="name" :options="sessions" placeholder="Select Session" v-on:input="selectSession"></v-select>
                      
                      <has-error
                        :form="form"
                        field="financial_year_id"
                      ></has-error>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="Branch">Branch</label>
                      <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="selectBranch"></v-select>
                      
                      <has-error
                        :form="form"
                        field="branch_id"
                      ></has-error>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label
                        >Branch Ledger <span class="red">*</span></label
                      ><br>
                      <span  style="display: flex; flex-flow: row wrap;
                        align-items: center;">
                        <table class="table table-bordered">
                          <thead style="background-color: #d6dddd;">
                            <th>Sr.</th>
                            <th>Ledger</th>
                            <th>Group</th>
                            <th>Opening Balance</th>
                          </thead>
                          <tbody v-for="(ledgerAccount, index) in ledgerAccounts" :key="index">
                            <tr>
                              <td>{{index + 1}}</td>
                              <td>
                                <p v-if="ledgerAccounts" class="text-bold">{{ledgerAccount.ledger.name}}</p>
                              </td>
                              <td width="30%">
                                <p v-if="ledgerAccounts">{{ledgerAccount.group.group}}</p>
                              </td>
                          <!-- <input
                            v-model="ledgerAccount.id"
                            type="number"
                            name="session"
                            style="width:42% "
                            class="form-control"
                            placeholder="EMI"
                            :class="{
                              'is-invalid': form.errors.has('noOfPayments'),
                            }"
                          />
                          <has-error
                            :form="form"
                            field="noOfPayments"
                          ></has-error>
                        -->
                            <td width="30%">
                              <input
                                v-model="ledgerAccount.openingBalance"
                                type="number"
                                step=".01"
                                name="openingBalance"
                                class="form-control"
                                placeholder="Opening Balance"
                                :class="{
                                  'is-invalid': form.errors.has('openingBalance'),
                                }"
                              />
                              <has-error
                                :form="form"
                                field="openingBalance"
                              ></has-error>
                              </td> 
                            </tr>
                          </tbody>
                        </table>
                      </span>
                    </div>
                    
                  </div>

                  <!-- <div class="col-sm-6">
                    <div class="form-group">
                      <label>Remark <span class="red">*</span></label>
                      <input
                        v-model="form.remark"
                        type="text"
                        name="remark"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('remark'),
                        }"
                      />
                      <has-error
                        :form="form"
                        field="remark"
                      ></has-error>
                    </div>
                    <div class="form-group">
                      <label
                        >Select Status <span class="red">*</span></label
                      >
                      <select
                        v-model="form.status"
                        name="status"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('status'),
                        }"
                      >
                        <option v-if="!form.status" selected value="">
                          Select Status
                        </option>
                        <option value="active">Active</option>
                        <option value="inActive">Inactive</option>
                      </select>
                      <has-error :form="form" field="status"></has-error>
                    </div>
                  </div> -->
                </div>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <div class="modal-footer text-center">
            <button
              v-show="!editMode"
              type="submit"
              class="btn btn-success"
            >
              CREATE
            </button>
            <button v-show="editMode" type="submit" class="btn btn-success">
              UPDATE
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
            >
              CANCEL
            </button>
          </div>
        </form>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
  <div class="modal fade" id="updateModal">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header bg-aqua">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 v-show="editMode" class="modal-title">Update</h4>
          
        </div>
        <form @submit.prevent="editMode ? updateRecord() : createFYOpeningBalance()">
          <div class="modal-body">
            <!-- general form elements disabled -->
            <div class="card card-warning">
              <!-- /.card-header -->
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-6">
                    <!-- text input -->
                    <div class="form-group">
                      <label for="Session">Session</label>
                      <v-select v-model="session" name="financial_year_id" label="name" :options="sessions" placeholder="Select Session" v-on:input="selectSession"></v-select>
                      
                      <has-error
                        :form="form"
                        field="financial_year_id"
                      ></has-error>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="Branch">Branch</label>
                      <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="selectBranch"></v-select>
                      
                      <has-error
                        :form="form"
                        field="branch_id"
                      ></has-error>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <input
                        v-model="form.openingBalance"
                        type="number"
                        step=".01"
                        name="openingBalance"
                        class="form-control"
                        placeholder="Opening Balance"
                        :class="{
                          'is-invalid': form.errors.has('openingBalance'),
                        }"
                      />
                      <has-error
                        :form="form"
                        field="openingBalance"
                      ></has-error>
                    </div>
                    
                  </div>

                  <!-- <div class="col-sm-6">
                    <div class="form-group">
                      <label>Remark <span class="red">*</span></label>
                      <input
                        v-model="form.remark"
                        type="text"
                        name="remark"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('remark'),
                        }"
                      />
                      <has-error
                        :form="form"
                        field="remark"
                      ></has-error>
                    </div>
                    <div class="form-group">
                      <label
                        >Select Status <span class="red">*</span></label
                      >
                      <select
                        v-model="form.status"
                        name="status"
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('status'),
                        }"
                      >
                        <option v-if="!form.status" selected value="">
                          Select Status
                        </option>
                        <option value="active">Active</option>
                        <option value="inActive">Inactive</option>
                      </select>
                      <has-error :form="form" field="status"></has-error>
                    </div>
                  </div> -->
                </div>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <div class="modal-footer text-center">
            <button
              v-show="!editMode"
              type="submit"
              class="btn btn-success"
            >
              CREATE
            </button>
            <button v-show="editMode" type="submit" class="btn btn-success">
              UPDATE
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
            >
              CANCEL
            </button>
          </div>
        </form>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>   
</div>
</template>

<script>
import GetBranch from '../../mixins/BranchRecords'
export default {
  name: 'FYOpeningBalance',
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 10,
      table_search: '',
      editMode: false,
      branches: [],
      branch: {},
      branchDetails: {},
      sessions: [],
      session: {},
      sessionId: '',
      filterSession: {},
      ledgerAccounts: [],
      ledgerAccount: {},
      form: new Form({
        id: '',
        financial_year_id: '',
        branch_id: '',
        branch_ledger_id: '',
        ledger_id: '',
        group_id: '',
        openingBalance: '',
        branchLedgers: [],
        remark: '',
        status: ''
      }),
      // columns: [
      //   {
      //     label: 'NAME',
      //     field: 'name'
      //   },

      //   {
      //     label: 'SHORT NAME',
      //     field: 'remark'
      //   },
      //   {
      //     label: 'STATUS',
      //     field: 'Status'
      //   },

      //   {
      //     label: 'ACTIONS',
      //     field: 'id',
      //     type: 'number'
      //   }
      // ],
      rows: []
    }
  },
  mixins: [GetBranch],
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    getSessionWiseRecord () {
      this.sessionId = ''
      this.branchId = ''
      this.sessionId = this.filterSession.id
      this.changeFilter()
    },
    getBranchWiseRecord () {
      this.branchId = this.branchDetails.id
      this.changeFilter()
    },
    newModal () {
      this.editMode = false
      this.form.reset()
      this.ledgerAccounts = []
      this.branchDetails = {}
      this.filterSession = {}
      $('#newModal').modal({backdrop: 'static', keyboard: false})
      if (this.branch) {
        this.form.branch_id = this.branch.id
        // var rowsData = this.rows
        this.$axios
        .get('branchledger?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          var ledgerAccounts = data.data
          $.each(data.data, function (key, value) {
            ledgerAccounts[key].branch_ledger_id = value.id
            var BrLedgerOpeningBalance = _.find(this.rows, function (o) { return o.branch_ledger_id === value.id })
            if (BrLedgerOpeningBalance) {
              ledgerAccounts[key].openingBalance = BrLedgerOpeningBalance.openingBalance
            }
          }.bind(this))
          this.ledgerAccounts = ledgerAccounts
        }).catch(function (error) { console.log(error) })
      }
    },
    selectSession () {
      this.form.financial_year_id = this.session.id
    },
    selectBranchLedger () {
      this.form.branch_ledger_id = this.ledgerAccount.id
      this.form.ledger_id = this.ledgerAccount.ledger_id
      this.form.group_id = this.ledgerAccount.group_id
    },
    selectBranch () {
      this.form.branch_id = this.branch.id
      // var rowsData = this.rows
      this.$axios
        .get('branchledger?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          var ledgerAccounts = data.data
          $.each(data.data, function (key, value) {
            ledgerAccounts[key].branch_ledger_id = value.id
            var BrLedgerOpeningBalance = _.find(this.rows, function (o) { return o.branch_ledger_id === value.id })
            if (BrLedgerOpeningBalance) {
              ledgerAccounts[key].openingBalance = BrLedgerOpeningBalance.openingBalance
            }
          }.bind(this))
          this.ledgerAccounts = ledgerAccounts
          // $.each(this.ledgerAccounts, function (key, value) {
          //   this.ledgerAccounts[key].name = value.ledger.name
          //   this.ledgerAccounts[key].branch_ledger_id = value.id
          //   console.log('=========')
          //   console.log(this.ledgerAccounts[key].branch_ledger_id)
          //   var singleRecord = _.result(_.find(rowsData, function (o) { return o.branch_ledger_id === this.ledgerAccounts[key].branch_ledger_id }), 'openingBalance')
          //   console.log(singleRecord)
          //   if (singleRecord) {
          //     this.ledgerAccounts[key].openingBalance = singleRecord.openingBalance
          //   }
          // }.bind(this))
        }).catch(function (error) { console.log(error) })
    },
    createFYOpeningBalance () {
      this.form.branchLedgers = this.ledgerAccounts
      this.$axios
        .post('fybulkaddupdateopnbalance', this.form, {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#newModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Record Added Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      // this.$axios
      //   .post('bank', this.form, {
      //     headers: { Authorization: 'Bearer ' + localStorage.token }
      //   })
      //   .then(() => {
      //     Fire.$emit('AfterCreate')
      //     $('#newModal').modal('hide')
      //     Toast.fire({
      //       icon: 'success',
      //       title: 'Bank Added Successfully'
      //     })
      //   })
      //   .catch(
      //     function (error) {
      //       Toast.fire({ icon: 'error', title: 'Please Try Again' })
      //       this.form.errors.errors = error.response.data.error
      //     }.bind(this)
      //   )
    },

    editModal (row) {
      this.editMode = true
      this.form.reset()
      $('#updateModal').modal({backdrop: 'static', keyboard: false})
      // $('#newModal').modal('show')
      this.form.fill(row)
      this.session = row.session
      this.session.name = row.session.session
      this.branch = row.branch
      this.ledgerAccount = row.ledger
    },
    updateRecord () {
      // console.log('update data')

      this.$axios
        .put('financialyearopeningbalance/' + this.form.id, this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          $('#updateModal').modal('hide')
          Toast.fire({
            icon: 'success',
            title: 'Record Updated Successfully'
          })
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
    },
    changeFilter (page = null, pg = null) {
      var pageUrl = 'financialyearopeningbalance?all=all'
      if (this.table_search) {
        pageUrl += `&searchTerm=${this.table_search}`
      }
      if (this.sessionId) {
        pageUrl += `&financial_year_id=${this.sessionId}`
      }
      if (this.branchId) {
        pageUrl += `&branch_id=${this.branchId}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.rows = data.data
        }).catch(function (error) { console.log(error) })
    },
    loadSessionData () {
      this.sessions = []
      this.session = {}
      let loader = this.$loading.show()
      this.$axios
        .get('session?all=all', {
          headers: { Authorization: 'Bearer ' + localStorage.token }
        })
        .then((response) => response.data)
        .then((data) => {
          loader.hide()
          this.sessions = data.data
          _.forEach(this.sessions, function (item, key) {
            this.sessions[key].name = item.session
          }.bind(this))
        })
        .catch(function (error) {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error
          })
        })
    }
  },

  created () {
    this.getBranch()
    this.loadSessionData()
    this.changeFilter()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
.content {
  padding: 0px;
}
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>



// WEBPACK FOOTER //
// FYOpeningBalance.vue?55b8a046